import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DialogComponent {
  @HostBinding('class.dialog') host = true;
  @Input() actionsAlign: 'center' | 'start' | 'end' = 'center';
  @Input() loading = false;
  @Input() hideClose = false;
}
